import { render, staticRenderFns } from "./TableTickets.vue?vue&type=template&id=2a13bfda"
import script from "./TableTickets.vue?vue&type=script&lang=js"
export * from "./TableTickets.vue?vue&type=script&lang=js"
import style0 from "./TableTickets.vue?vue&type=style&index=0&id=2a13bfda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports